module.exports = __webpack_public_path__ + "img/maintenance_pending.a7ab49be.svg";